import { render, staticRenderFns } from "./ai_upload_img.vue?vue&type=template&id=24eae2ec&scoped=true"
import script from "./ai_upload_img.vue?vue&type=script&lang=js"
export * from "./ai_upload_img.vue?vue&type=script&lang=js"
import style0 from "./ai_upload_img.vue?vue&type=style&index=0&id=24eae2ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24eae2ec",
  null
  
)

export default component.exports